import styled from "@emotion/styled";

export const TargetTrigger = styled.div`
  display: flex;
  padding: 0.5rem;
  border-radius: 0.5rem;
  width: 100%;
  margin-bottom: 0.5rem;
  font-weight: bold;

  &:hover {
    color: var(--mb-color-brand);
    background-color: var(--mb-color-bg-light);
  }
`;
